import { useEffect, useState, useCallback } from 'react';

const subdomainPattern = new RegExp(
    /^([a-z\d]([a-z\d-]*[a-z\d])*)$/i
);

function useSubdomainValidator(url, delay = 300) {
    const [valid, setValid] = useState(true);

    const validateUrl = useCallback(() => {
        setValid(subdomainPattern.test(url));
    }, [url]);

    useEffect(() => {
        const handler = setTimeout(validateUrl, delay);
        return () => clearTimeout(handler);
    }, [url, validateUrl, delay]);

    return valid;
}

export default useSubdomainValidator;